import { Component, Input, Output, EventEmitter, Renderer2, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpHeaders, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import {
  FormGroup,
  FormControl,
  FormArray,
  FormBuilder,
  Validators,
  NgForm,
} from '@angular/forms';

@Component({
  selector: 'app-save-new-sr',
  templateUrl: './save-new-sr.component.html',
  styleUrls: ['./save-new-sr.component.scss']
})
export class SaveNewSrComponent {
  @Input() serviceTypeInfo: any;

  constructor(  private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private http: HttpClient) {

  }
  ngOnInit() {
    console.log("savenewsrcomponetcame", this.serviceTypeInfo);
    
  }
}
